export interface ICadastro {
    CampoNome: string;
    Valor: string;
    id?: number;
}